import { useContext, useEffect } from "react";
import { getOwnerData } from "../../services/login/login.service";
import { formatOwnerData } from "../../../utils/ownerData/ownerData.util";
import { GetCifCupsRequestBody } from "../../models/cupsCifSelector/cupsCifSelector.model";
import TotalEnergiesContext from "../../store/context/TotalEnergiesContext";
import {
  clearFirstLoadCifCups,
  formatCifCups,
  initialCifCupsState,
  newLoadCipCups,
} from "../../../utils/components/cupsCifSelector/cupsCifSelector.util";
import { getCifCups } from "../../services/cupsCifSelector/cupsCifSelector.service";
import { OwnerDataCups } from "../../models/ownerData/ownerData.model";

const useOwnerData = () => {
  const { storageOwnerData, storageCifCupsState } =
    useContext(TotalEnergiesContext);

  useEffect(() => {
    let cups!: OwnerDataCups[];

    getOwnerData(undefined, "")
      .then((response) => {
        const {
          isAdministrator,
          idAdministrator,
          idClient,
          cups: cupsOwnerData,
        } = formatOwnerData(response);
        const getManagementsCifCupsRequestBody: GetCifCupsRequestBody = {
          userid: isAdministrator ? idAdministrator : idClient,
          isAdmin: isAdministrator,
        };
        cups = cupsOwnerData;
        storageOwnerData(response);
        storageCifCupsState(newLoadCipCups(initialCifCupsState, true));

        return getCifCups(getManagementsCifCupsRequestBody, "");
      })
      .then((cifCupsRaw) => {
        const formattedCifCups = formatCifCups(cifCupsRaw, cups);
        storageCifCupsState(clearFirstLoadCifCups(formattedCifCups));
      });
  }, []);
};

export default useOwnerData;
